// extracted by mini-css-extract-plugin
export default {"content":"eventRules_content__qKhJB"};